import { render, staticRenderFns } from "./RecommendationCenter.vue?vue&type=template&id=f1d6d430&"
import script from "./RecommendationCenter.vue?vue&type=script&lang=js&"
export * from "./RecommendationCenter.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports